import moment from 'moment-timezone'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Label, Segment, Tab } from 'semantic-ui-react'

import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import LaterParticipants from './later-participants'
import TodayParticipants from './today-participants'
import ArchivedParticipants from './archived-participants'
import { actions as participants } from '../../store/actions/participants'

class Participants extends Component {
    constructor(props) {
        super(props)
        this.state = {
            todays: [],
            laters: [],
            archived: []
        }
        autoBind(this)
    }

    componentDidMount() {
        console.log("componentDidMount")
        console.log("this.props.active_participants: ", this.props.active_participants)
        console.log("this.props.archived_participants: ", this.props.archived_participants)
        if (this.props.active_participants && this.props.archived_participants) {
            console.log("componentDidMount check passed")
            this.splitParticipants()
        }
    }

    componentDidUpdate(prevProps) {
        console.log("componentDidUpdate")
        console.log("this.props.active_participants: ", this.props.active_participants)
        console.log("prevProps.active_participants: ", prevProps.active_participants)
        console.log("this.props.archived_participants: ", this.props.archived_participants)
        console.log("prevProps.archived_participants: ", prevProps.archived_participants)
        if (
            prevProps.active_participants !== this.props.active_participants ||
            prevProps.archived_participants !== this.props.archived_participants
        ) {
            console.log("componentDidUpdate check passed")
            this.splitParticipants()
        }
        console.log("this.props.timezone: ", this.props.timezone)
        console.log("prevProps.timezone: ", prevProps.timezone)
        if (prevProps.timezone === undefined && this.props.timezone !== undefined) {
            console.log("componentDidUpdate timezone check passed")
            this.fetchParticipants(false)
            this.fetchParticipants(true)
        }
    }

    splitParticipants() {
        const todayStart = moment().tz(this.props.timezone).startOf('day').valueOf()
        const tomorrowStart = moment().tz(this.props.timezone).add(1, 'day').startOf('day').valueOf()
        console.log("todayStart ", todayStart)
        console.log("tomorrowStart ", tomorrowStart)
        const todays = (this.props.active_participants || []).filter(p =>
            p.next_session && p.next_session >= todayStart && p.next_session < tomorrowStart
        )

        const laters = (this.props.active_participants || []).filter(p =>
            !p.next_session || p.next_session < todayStart || p.next_session >= tomorrowStart
        )

        const archived = this.props.archived_participants || []
        console.log("todays ", todays)
        console.log("laters ", laters)
        console.log("archived ", archived)
        this.setState({ todays, laters, archived })
    }

    fetchParticipants(archived) {
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients?archived=${archived ? 1 : 0}`
        })
        .then((response) => {
            if (archived) {
                this.props.setArchivedParticipants(response.data.patients)
            } else {
                this.props.setActiveParticipants(response.data.patients)
            }
        })
        .catch((error) => {
            console.error('Failed to fetch participants.', error)
        })
    }

    selectParticipant(participant) {
        if (!participant) return
        this.props.history.push(`/participants/${participant.id}`)
    }

    renderActiveParticipants() {
        return (
            <div
                className='l1 participants-list'
                style={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}
            >
                <Segment className='counter active'>
                    {tr('ACTIVE_PARTICIPANTS')}
                    <Label>{this.props.active_participants ? this.props.active_participants.length : ""}</Label>
                </Segment>
                {this.state.todays.length > 0 && (
                    <TodayParticipants
                        participants={this.state.todays}
                        selectedParticipant={this.props.selectedParticipant}
                        language={this.props.language}
                        timezone={this.props.timezone}
                        onSelectParticipant={this.selectParticipant}
                        flex={0.4} // 40% of height
                    />
                )}
                {this.state.laters.length > 0 && (
                    <LaterParticipants
                        participants={this.state.laters}
                        selectedParticipant={this.props.selectedParticipant}
                        language={this.props.language}
                        timezone={this.props.timezone}
                        onSelectParticipant={this.selectParticipant}
                        flex={this.state.todays.length > 0 ? 0.6 : 1} // remaining or full
                    />
                )}
            </div>
        )
    }

    renderArchivedParticipants() {
        return (
            <div
                className='l1 participants-list'
                style={{flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0}}
            >
                <Segment className='counter archived'>
                    {tr('ARCHIVED_PARTICIPANTS')}
                    <Label>{this.props.archived_participants ? this.props.archived_participants.length : ""}</Label>
                </Segment>
                <ArchivedParticipants
                    participants={this.state.archived}
                    selectedParticipant={this.props.selectedParticipant}
                    language={this.props.language}
                    timezone={this.props.timezone}
                    onSelectParticipant={this.selectParticipant}
                    flex={1} // full height
                />
            </div>
        )
    }

    render() {
        const panes = [
            {
                menuItem: tr('ACTIVE'),
                render: () => (
                    <Tab.Pane attached={false} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                        {this.renderActiveParticipants()}
                    </Tab.Pane>
                )
            },
            {
                menuItem: tr('ARCHIVE'),
                render: () => (
                    <Tab.Pane attached={false} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                        {this.renderArchivedParticipants()}
                    </Tab.Pane>
                )
            }
        ]

        return (
            <Segment
                className='participants'
                style={{display: 'flex', flexDirection: 'column', height: '100%'}}
            >
                <Tab
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    style={{flex: 1, display: 'flex', flexDirection: 'column'}}
                />
            </Segment>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.settings.language,
    active_participants: state.participants.active_participants,
    archived_participants: state.participants.archived_participants,
    timezone: state.settings.timezone,
    userTokens: state.users.userTokens
})

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        setActiveParticipants: _participants.setActiveParticipants,
        setArchivedParticipants: _participants.setArchivedParticipants,
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Participants))



// WEBPACK FOOTER //
// ./src/components/participants/index.js